import React from 'react';
import PropTypes from 'prop-types';
import { Autocomplete, TextField } from '@mui/material';

function LevelAutocomplete({ options, value, onChange, getOptionLabel, getOptionDisabled }) {
  return (
    <Autocomplete
      size="small"
      options={options}
      value={value}
      onChange={(_, newValue) => onChange(newValue)}
      getOptionLabel={getOptionLabel}
      getOptionDisabled={getOptionDisabled}
      isOptionEqualToValue={(option, val) => option?._id === val?._id || option?.key === val?.key}
      renderInput={(params) => (
        <TextField
          {...params}
          size="small"
          sx={{
            minWidth: 100,
            '& .MuiOutlinedInput-root': {
              backgroundColor: 'hsl(var(--background))',
              borderRadius: '0.375rem',
              fontSize: '0.75rem',
              '& fieldset': {
                borderColor: 'hsl(var(--border))',
              },
              '&:hover fieldset': {
                borderColor: 'hsl(var(--border))',
              },
              '&.Mui-focused fieldset': {
                borderColor: 'hsl(var(--primary))',
                borderWidth: '1px',
              },
            },
            '& .MuiInputBase-input': {
              color: 'hsl(var(--foreground))',
              padding: '4px 8px !important',
            },
          }}
        />
      )}
      sx={{
        '& .MuiAutocomplete-endAdornment': {
          '& .MuiSvgIcon-root': {
            fontSize: '1rem',
          },
        },
      }}
    />
  );
}

LevelAutocomplete.propTypes = {
  options: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  value: PropTypes.shape({}),
  onChange: PropTypes.func.isRequired,
  getOptionLabel: PropTypes.func.isRequired,
  getOptionDisabled: PropTypes.func,
};

LevelAutocomplete.defaultProps = {
  value: null,
  getOptionDisabled: () => false,
};

export default LevelAutocomplete;
